import { Component } from 'react';
import { toast } from 'react-toastify';
import AuthenticationContext from "../Store/Authentication-Context";
import { API_ROUTE, Routes } from "./Constants";
import Axios from "axios";
class ErrorHandler extends Component {
    static contextType = AuthenticationContext;
    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        const orgId = urlParams.get('orgId') ? urlParams.get('orgId') : sessionStorage.getItem('ManageOrgId');
        const orgName = urlParams.get('orgName') ? urlParams.get('orgName') : sessionStorage.getItem('ManageOrgName');
        this.state = {
            orgId: orgId,
            orgName: orgName,
            hasError: false
        };
        this.toastShown = false;
        this.writeLog = this.writeLog.bind(this);
        this.errorMessage = this.errorMessage.bind(this);
    }

    //static getDerivedStateFromError(error) {
    //    //if (!this.toastShown) {
    //        //this.toastShown = true;
    //        //this.writeLog(this.errorMessage(error))
    //    //toast.error('Something went wrong');
    //        //alert(error)
    //        ////setTimeout(() => {
    //        ////    //this.setState({ hasError: true });
    //        ////    window.location.reload();""
    //        ////}, 3000);
    //    //}
    //    //return { hasError: true };
    //}

    componentDidCatch(error, info) {
        //console.error("Error caught by Error Boundary:", error);
        //console.error("Error Info:", info);
        if (!this.toastShown) {
            this.toastShown = true;
           this.writeLog(this.errorMessage(error, info),"");
            toast.warn('An unexpected error occurred.');
            //setTimeout(() => {
            //    //this.setState({ hasError: true });
            //    window.location.reload();
            //}, 3000);
        }
        
    }

    async writeLog(errorMessage,type) {

         const { setAuthContext } = this.context;
         try {
             var tokenString = await setAuthContext("", new Date());

             const config = {
                 headers: {
                     Authorisation: `Bearer ` + tokenString,
                     CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                 },
             };
             const pathname = window.location.pathname;
             const pageName = pathname.substring(pathname.lastIndexOf("/") + 1);
             const inputData = {
                 EventType: "ERR",
                 PublicView: false,
                 EventDetail: "FrontEnd - " + this.state.orgName + " - " + (pageName ? pageName : "-") +" Error:"+ errorMessage,
                 EventSource: "RCT",
                 EventUser: sessionStorage.getItem("UserName"),
                 OrgID: this.state.orgId,

             };

             await Axios.post(API_ROUTE + Routes.WRITE_LOG, inputData, config)
                 .then((response) => {
                     if (response.data.result) {


                     }
                     if (type !== "promise") {
                     setTimeout(() => {
                         //this.setState({ hasError: true });
                         window.location.reload();
                     }, 1000);
                     }
                     
                 }).catch((reason) => {
                     //console.log("catch" + reason);
                     if (reason?.response?.status === 440) {
                         window.location.href = "/TimeoutErrorHandler";
                     }
                     ////setTimeout(() => {
                     ////    //this.setState({ hasError: true });
                     ////    window.location.reload();
                     ////}, 1000);
                 });;
         }
         catch (error) {
             //console.error("Error:", error);

             if (error?.response?.status === 440) {
                 window.location.href = "/TimeoutErrorHandler";
             }
             ////setTimeout(() => {
             ////    //this.setState({ hasError: true });
             ////    window.location.reload();
             ////}, 1000);
         }
    

    }

    errorMessage(errorOrEvent, info) {
        let errorDetails = {
            url: window.location.href,
            message: 'Unknown message',
            name: 'UnknownError',
            stack: 'No stack trace available',
            filename: 'unknown',
            functionName: 'anonymous',
            timestamp: new Date().toISOString(),
        };
        let errorString=""
        try {
            if (errorOrEvent instanceof Error) {
                // This is the case for componentDidCatch
                const stackLines = errorOrEvent.stack?.split('\n') || [];
                const relevantLine = stackLines[1] || '';
                const functionMatch = relevantLine.match(/at\s+(.*?)\s+\((.*?):(\d+):(\d+)\)/) ||
                    relevantLine.match(/at\s+(.*?):(\d+):(\d+)/);

                errorDetails = {
                    ...errorDetails,
                    message: errorOrEvent.message,
                    name: errorOrEvent.name,
                    stack: errorOrEvent.stack,
                    filename: functionMatch?.[2] || 'unknown',
                    functionName: functionMatch?.[1] || 'anonymous',
                };

                if (info && info.componentStack) {
                    errorDetails.componentStack = info.componentStack;
                }

            }
            else {
                // This is the case for window.onerror or unhandledrejection
                const stackLines = (errorOrEvent.error?.stack || errorOrEvent.stack || '').split('\n');
                const relevantLine = stackLines[1] || '';
                const functionMatch = relevantLine.match(/at\s+(.*?)\s+\((.*?):(\d+):(\d+)\)/) ||
                    relevantLine.match(/at\s+(.*?):(\d+):(\d+)/);

                errorDetails = {
                    ...errorDetails,
                    message: errorOrEvent.error?.message || errorOrEvent.message || 'Unknown message',
                    name: errorOrEvent.error?.name || 'UnknownError',
                    stack: errorOrEvent.error?.stack || 'No stack trace available',
                    filename: functionMatch?.[2] || errorOrEvent.filename || 'unknown',
                    functionName: functionMatch?.[1] || 'anonymous',
                };
            }

            errorString = `
        URL          : ${errorDetails.url}
        Error Name   : ${errorDetails.name}
        Function     : ${errorDetails.functionName}
        Message      : ${errorDetails.message}
        Stack Trace  : ${errorDetails.stack}
        File         : ${errorDetails.filename}
        Timestamp    : ${errorDetails.timestamp}
        ${errorDetails.componentStack ? `Component Stack: ${errorDetails.componentStack}` : ''} `;
        }
        catch (err) {
            errorDetails = {
                url: window.location.href,
                message: 'Unknown message',
                name: 'UnknownError',
                stack: 'No stack trace available',
                filename: 'unknown',
                functionName: 'anonymous',
                timestamp: new Date().toISOString(),
            };
            errorString = `
        URL          : ${errorDetails.url}
        Error Name   : ${errorDetails.name}
        Function     : ${errorDetails.functionName}
        Message      : ${errorDetails.message}
        Stack Trace  : ${errorDetails.stack}
        File         : ${errorDetails.filename}
        Timestamp    : ${errorDetails.timestamp}
        ${errorDetails.componentStack ? `Component Stack: ${errorDetails.componentStack}` : ''} `;
        }
        

        return errorString;
    }
    componentDidMount() {
        window.addEventListener('error', (event) => {
            if (!this.toastShown) {
                console.log(event);
                const errorMsg = this.errorMessage(event).toLowerCase();
                if (['script error.', 'tawk'].some(str => errorMsg.includes(str))) {
                    console.log('error in tawk')
                    //this.writeLog(errorMsg, "");

                }
                else {
                    this.toastShown = true;
                    toast.warn('An unexpected error occurred.');
                    this.writeLog(errorMsg, "");                   
                }
            }
            
        });

        window.addEventListener('unhandledrejection', (event) => {
            ////const reason = event.reason;
            if (!this.toastShown) {
                this.toastShown = true;
                //this.writeLog(this.errorMessage(event),"promise")
                ////try {
                    
                ////    let message = 'Unknown error';
                ////    let name = 'Error';
                ////    let stack = '';
                ////    let filename = '';
                ////    let functionname = '';

                ////    let errorDetails = {
                ////        url: window.location.href,
                ////        message: 'Unknown message',
                ////        name: 'UnknownError',
                ////        stack: 'No stack trace available',
                ////        filename: 'unknown',
                ////        functionName: 'anonymous',
                ////        timestamp: new Date().toISOString(),
                ////    };
                ////    if (reason instanceof Error) {
                ////        message = reason.message || message;
                ////        name = reason.name || name;
                ////        stack = reason.stack || '';

                ////        if (stack) {
                ////            const stackLines = stack.split('\n');
                ////            if (stackLines.length > 1) {
                ////                const match = stackLines[1].match(/at (\S+) \((.*):(\d+):(\d+)\)/) ||
                ////                    stackLines[1].match(/at (.*):(\d+):(\d+)/); // For anonymous functions

                ////                if (match) {
                ////                    functionname = match[1] || 'anonymous';
                ////                    filename = match[2] || 'unknown';
                ////                }
                ////            }
                ////        }
                ////        errorDetails = {
                ////            ...errorDetails,
                ////            message: "unhandledrejection: " + message,
                ////            name: name,
                ////            stack: stack,
                ////            filename: filename,
                ////            functionName: functionname,
                ////        };
                ////        const errorString = `
                ////        URL          : ${errorDetails.url}
                ////        Error Name   : ${errorDetails.name}
                ////        Function     : ${errorDetails.functionName}
                ////        Message      : ${errorDetails.message}
                ////        Stack Trace  : ${errorDetails.stack}
                ////        File         : ${errorDetails.filename}
                ////        Timestamp    : ${errorDetails.timestamp}
                ////        ${errorDetails.componentStack ? `Component Stack: ${errorDetails.componentStack}` : ''}
                ////    `;
                ////    }
                ////}
                ////catch (err) {
                ////    console.log(err)
                ////}
            }
        });
    }

    render() {
        return this.props.children
    }
}

export default ErrorHandler;